import { createAsyncThunk } from '@reduxjs/toolkit'
import optinServices from 'services/optin'

export const getOptinInfo = createAsyncThunk(
	'optin/get',
	optinServices.getOptinInfo
)
